import { graphql } from '@/gql';
import type { EndSubscriptionMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const endSubscription = async (variables: EndSubscriptionMutationVariables) => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation EndSubscription($code: String!, $phoneNumber: String!, $reason: String!) {
        endSubscription(code: $code, phoneNumber: $phoneNumber, reason: $reason)
      }
    `),
    variables,
  });

  return response.data?.endSubscription;
};
